import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';

const styles = theme => ({
  checked: {
    color: theme.palette.primary['A700'],
  },
});

const CheckboxesWidget = props => {
  // console.log(props)
  const {
    // classes,
    // //id,
    // value,
    // required,
    // disabled,
    // readonly,
    // label,
    // autofocus,
    // onChange,

    classes,
    formContext,
    options,
    value,
    required,
    disabled,
    readonly,
    autofocus,
    onChange,
  } = props;
  const {enumOptions} = options
  const signed = formContext && formContext.signedAt && formContext.signedAt !== undefined

  const _onChange = (selectedValue) => {
    const {value} = props;

    if (value.indexOf(selectedValue)<0) {
      onChange(value.concat(selectedValue));

    } else if (value.indexOf(selectedValue)>-1) {        
      onChange(value.filter(someValue => someValue !== selectedValue));
    }
  };
  return (

    <FormControl disabled={disabled || formContext.formStatus !== 'editable'}>
      {console.log('value',value)}
      {enumOptions.map((option, i) => {
          return (
            <FormControlLabel
              key={i}
              control={
                <Checkbox
                  //id={id}
                  checked={value.indexOf(option.value)<0 ? false : true}
                  required={required}
                  disabled={signed || disabled || readonly}
                  autoFocus={autofocus}
                  classes={{
                    checked: classes.checked,
                  }}
                  onChange={event => _onChange(option.value)}
                />
              }
              label={option.label}
            />
          );
        })}
    </FormControl>
  );
};

CheckboxesWidget.defaultProps = {
  autofocus: false,
};

CheckboxesWidget.propTypes = {
  //id: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  label: PropTypes.string,
  value: PropTypes.array,
  formContext: PropTypes.object.isRequired,
  options: PropTypes.shape({
    enumOptions: PropTypes.array,
    inline: PropTypes.bool,
  }).isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,

};

export default withStyles(styles)(CheckboxesWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/CheckboxesWidget.js